/*
 * Landing-cockpit micro-formatters (nb-NO), mirroring lib/format.ts conventions:
 * null/NaN always renders the em dash, units are glued with NBSP so values
 * never wrap. Kept local to components/landing — these units (seconds, ms→s,
 * CLS) exist only on the landing intelligence view.
 */

export const EM_DASH = '—';

const NBSP = ' ';
const intFmt = new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 0 });
const oneDecFmt = new Intl.NumberFormat('nb-NO', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
const clsFmt = new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 2 });
const countFmt = new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 1 });

/** Seconds → '42 s' or '1 min 23 s'. null → em dash. */
export function formatSeconds(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  const s = Math.round(value);
  if (s < 60) return `${intFmt.format(s)}${NBSP}s`;
  const min = Math.floor(s / 60);
  const rest = s % 60;
  return `${intFmt.format(min)}${NBSP}min ${intFmt.format(rest)}${NBSP}s`;
}

/** Milliseconds → seconds with 1 decimal: 2400 → '2,4 s'. null → em dash. */
export function formatMs(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  return `${oneDecFmt.format(value / 1000)}${NBSP}s`;
}

/** Cumulative Layout Shift (unitless, 2 dp max). null → em dash. */
export function formatCls(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  return clsFmt.format(value);
}

/** Small ratio (e.g. sessions per user) with at most 1 decimal. null → em dash. */
export function formatCount1(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return EM_DASH;
  return countFmt.format(value);
}
